import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { sendNotification } from 'src/redux/actions/notifications';
import {
  getLocale,
  getAllPexunit,
  getAllPexunitIds,
  getUser,
  getTimeStamp,
  getBidData
} from 'src/redux/selectors';
import {
  addPexunit,
  deletePexunit,
  findAllPexunit
} from 'src/redux/actions/pexunit';
import {
  addRequest,
  findJobNumbers,
  findTechnicians
} from 'src/redux/actions/pexrequest';
import { withRouter, Link } from 'react-router-dom';

class Pexunit extends Component {
  render = () => {
    const {
      Layout,
      pexunit,
      user,
      addPexunit,
      deletePexunit,
      findAllPexunit,
      sendNotification,
      push,
      addRequest,
      findJobNumbers,
      findTechnicians,
      history
    } = this.props;
    return (
      <Layout
        pexunit={pexunit}
        user={user}
        addPexunit={addPexunit}
        deletePexunit={deletePexunit}
        findAllPexunit={findAllPexunit}
        addRequest={addRequest}
        sendNotification={sendNotification}
        push={push}
        findJobNumbers={findJobNumbers}
        findTechnicians={findTechnicians}
        history={history}
      />
    );
  };
}

const mapStateToProps = state => ({
  currentLocale: getLocale(state) || {},
  pexunit: state.pexunit.allPexunit || [],
  user: state.user.user || {}
});

const mapDispatchToProps = {
  getLocale,
  addPexunit,
  deletePexunit,
  findAllPexunit,
  addRequest,
  sendNotification,
  push,
  findJobNumbers,
  findTechnicians
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Pexunit)
);
